import { Stack } from "@mui/material";
import Supplier from "Components/card/Supplier";
import FullySupplierSkeleton from "Components/skeleton/FullySupplierSkeleton";
import { LgTextMd } from "Components/text/LgText";
import { COLORS } from "constants/layout";
import { SEARCH_PARAMS } from "constants/routes";
import { useQueryParam } from "helpers/search";
import useGetData from "hooks/useGetData";
import { useTranslation } from "hooks/useTranslation";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { apiGetFeaturedSuppliers } from "services/api/company";
import { ParamsType } from "types/params";
import { SupplierType } from "types/supplier";

type Props = {
  isPageDetail?: boolean
  isNotShowButton?: boolean
};

const SponsorSuppliers = (props: Props) => {
  const t = useTranslation();
  const {isPageDetail, isNotShowButton} = props;
  const searchKeyword = useQueryParam(SEARCH_PARAMS.keyword);
  const { categoryId } = useParams<ParamsType>();

  const queryParams:Record<string, string> ={};
  if(searchKeyword) queryParams.keyword = searchKeyword;
  if(categoryId) queryParams.category_id = categoryId;

  const { isLoading, data } = useGetData({
    promise: () =>
      // apiGetFeaturedSuppliers({
      //   keyword: searchKeyword,
      //   category_id: categoryId,
      // }),
      apiGetFeaturedSuppliers(queryParams),
    deps: [searchKeyword, categoryId],
  });
  const suppliers: SupplierType[] = useMemo(() => data?.data || [], [data]);

  if (suppliers.length === 0 && !isLoading) return null;

  return (
    <Stack
      p={{ xs: 1, md: 2 }}
      spacing={1}
      bgcolor={COLORS.yellow[50]}
      borderRadius={3}
      padding={'12px !important'}
      marginTop={'12px !important'}
      maxWidth={'100%'}
      className="sponsor_suppliers"
    >
      <LgTextMd>{t("sponsor_suppliers")}</LgTextMd>
      {isLoading &&
        Array.from(new Array(1)).map((_, index) => (
          <FullySupplierSkeleton key={index} />
        ))}
      {/* {!isLoading && <Supplier company={suppliers[0]} />} */}
      {!isLoading && (
        suppliers.map((item, index) => (
          <Supplier company={item} key={index} isPageDetail={isPageDetail} isNotShowButton={isNotShowButton}/>
        ))
      )}
    </Stack>
  );
};

export default SponsorSuppliers;
